import { useEffect, useState } from "react";

/**
 * Height of the sticky site header, so other sticky elements can sit below it
 * instead of sliding underneath.
 */
const useStickyHeaderOffset = (headerId = "site-header") => {
	const [offset, setOffset] = useState(0);

	useEffect(() => {
		const header = document.getElementById(headerId);
		if (!header) return undefined;

		const measure = () => setOffset(header.offsetHeight || 0);
		measure();

		if (typeof ResizeObserver !== "undefined") {
			const observer = new ResizeObserver(measure);
			observer.observe(header);
			return () => observer.disconnect();
		}

		window.addEventListener("resize", measure);
		return () => window.removeEventListener("resize", measure);
	}, [headerId]);

	return offset;
};

export default useStickyHeaderOffset;
